
import { gql } from "graphql-tag";

import ClpFacetItem from "./ClpFacetItem";
import { documentLink } from "~/app/prismic/prismic-fragments";
import { normalizeEdges } from "~/utils";
import { siteNavigationSchemaMixin } from "~/mixins";

const COLLECTION_FACET_QUERY = gql`
  query allCollection_facets($uid: String!) {
    allCollection_facets(where: { collection_uid: $uid }) {
      edges {
        node {
          ... on Collection_facet {
            facet_title
            facet_values {
              title
              icon
              plp_page_link {
                ...documentLink
              }
            }
          }
        }
      }
    }
  }
  ${documentLink}
`;

export default {
  name: "ListOfFacets",

  components: { ClpFacetItem },

  mixins: [siteNavigationSchemaMixin],

  inject: {
    title: { default: "" },
    // Inject method to add schema to parent page
    addPageSchema: { default: null },
  },

  props: { slice: { type: Object, required: true } },

  data: () => ({ facetFields: [], navigationItems: [] }),

  async fetch() {
    const allFacets = await this.$prismicGql.request({
      query: COLLECTION_FACET_QUERY,
      variables: { uid: this.$route.params.handle },
    });
    this.facetFields = normalizeEdges(allFacets?.allCollection_facets);

    const attachedFacets = this.slice.fields.map(
      field => field?.shop_by_facets?.facet_title?.[0]?.text ?? ""
    );
    const getMatchedIndex = node =>
      attachedFacets.indexOf(node?.facet_title?.[0]?.text ?? "");

    this.facetFields = this.facetFields
      .filter(field => {
        const fieldName = field?.facet_title?.[0]?.text ?? "";
        return attachedFacets.includes(fieldName);
      })
      .sort((a, b) => {
        return getMatchedIndex(a) - getMatchedIndex(b);
      });

    // Build navigationItems for SiteNavigationElement schema
    this.navigationItems = this.facetFields.flatMap(
      field =>
        (field.facet_values || [])
          .filter(value => value.plp_page_link && value.plp_page_link._meta)
          .map(value => {
            // Extract text properly from Prismic rich text field
            const title = value.title || [];
            const name = title
              .map(block => block?.text || "")
              .join(" ")
              .trim()
              .replace(/\s+/g, " "); // Normalize multiple spaces

            return {
              name,
              url: this.$prismic.asLink(value.plp_page_link),
            };
          })
          .filter(item => item.name) // Remove items with empty names
    );

    // Add schema to parent page via provide/inject if available
    if (this.addPageSchema && this.siteNavigationSchemaScript) {
      this.addPageSchema(this.siteNavigationSchemaScript);
    }
  },

  computed: {
    hasTitle() {
      return this.slice.primary?.title1?.[0]?.text;
    },
  },
};
